const C = {
    AUTH_SUCCESS: 'AUTH_SUCCESS',
    LOGOUT: 'LOGOUT',
    REQUEST_RESULTS: 'REQUEST_RESULTS',
    CHANGE_RECIPE: 'CHANGE_RECIPE',
    GET_RECIPES: 'GET_RECIPES',
    GET_RECIPE: 'GET_RECIPE',
    CLEAR_RICIPE_STATE: 'CLEAR_RICIPE_STATE',
    SHOW_LOADER: 'SHOW_LOADER',
    HIDE_ALERT: 'HIDE_ALERT',
    SHOW_ALERT: 'SHOW_ALERT',
    GET_KEYS: 'GET_KEYS',
    CHANGE_PAGE: 'CHANGE_PAGE'
}

export default C